<template>
  <vx-card no-shadow>

    <!-- Img Row -->

<!--      <vs-avatar :src="activeUserInfo.photoURL" size="70px" class="mr-4 mb-4" />-->
<!--      <div>-->
<!--        <vs-button class="mr-4 sm:mb-0 mb-2" disabled>Upload photo</vs-button>-->
<!--        <vs-button type="border" color="danger" disabled>Remove</vs-button>-->
<!--        <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p>-->
<!--      </div>-->
      <!-- <profile-image-section v-bind:avatar="current_user.avatar" v-bind:auth_id="current_user.id"/> -->

<!--    <div class="vx-row mb-8">-->
<!--      <div class="vx-col md:w-full md:mb-0">-->
<!--        <small class="label">Enable 2FA?</small>-->
<!--        <vs-switch @input="onChange2FA()" v-model="current_user.is_google_2fa_enable" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">-->
<!--          <span slot="on">Yes</span>-->
<!--          <span slot="off">No</span>-->
<!--        </vs-switch>-->
<!--      </div>-->
<!--    </div>-->

    <!-- DARK MODE -->
    <div class="mt-4 mb-12 hidden">
      <h5 class="mb-2">Theme Mode</h5>
      <div>
        <vs-radio v-model="themeMode" vs-value="light" class="mr-4" vs-name="theme-mode-light">Light</vs-radio>
        <vs-radio v-model="themeMode" vs-value="dark" class="mr-4" vs-name="theme-mode-dark">Dark</vs-radio>
      </div>
    </div>
    <!-- END DARK MODE -->

<!--    <vs-alert v-if="current_user.is_active === 0" icon-pack="feather" icon="icon-info" class="h-full my-4" color="warning">-->
<!--      <span>Your account is not verified.</span>-->
<!--    </vs-alert>-->
<!--    <vs-alert v-else icon-pack="feather" icon="icon-info" class="h-full mt4 mb-12" color="success">-->
<!--      <span>Your account is verified.</span>-->
<!--    </vs-alert>-->

    <!-- Info -->
    <vs-input readonly class="w-full mb-base" label-placeholder="Full Name" v-model="current_user.fullName"></vs-input>
    <vs-input readonly class="w-full mb-base" label-placeholder="Email" v-model="current_user.email"></vs-input>
    <vs-input readonly class="w-full mb-base" label-placeholder="Organization" v-model="org"></vs-input>
    <!-- <vs-input readonly class="w-full mb-base" label-placeholder="Mobile" v-model="current_user.mobile"></vs-input>
    <vs-input readonly class="w-full mb-base" label-placeholder="Employee No" v-model="current_user.employee_no"></vs-input>
    <vs-input readonly class="w-full mb-base" label-placeholder="Job Title" v-model="current_user.job_title"></vs-input> -->

    <!-- Save & Reset Button -->
<!--    <div class="flex flex-wrap items-center justify-end">-->
<!--      <vs-button disabled class="ml-auto mt-2">Save Changes</vs-button>-->
<!--      <vs-button class="ml-4 mt-2" type="border" color="warning" disabled>Reset</vs-button>-->
<!--    </div>-->
    <two-f-a-pop-up v-on:refreshData="getCurrentUser" ref="twoFAPopUp"/>
    <vs-prompt
      @cancel="onClick2FADisableCancel"
      @accept="onClick2FADisable"
      @close="onClick2FADisableCancel"
      title="Confirm"
      accept-text="Disable"
      color="danger"
      :active.sync="active2FADisabledPrompt">
      <div class="con-exemple-prompt">
        <span>Enter your password</span>
        <vs-input type="password" v-model="password" class="mt-3 w-full" />
      </div>
    </vs-prompt>
  </vx-card>
</template>

<script>
import profile from '@/apis/profile.js'
import TwoFAPopUp from "@/components/popups/user-settings/TwoFAPopUp";
import {RepositoryFactory} from '@/repository/RepositoryFactory'
import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from "@/mixins/ErrorMessages";
const StaffRepository = RepositoryFactory.get('staff');
import ProfileImageSection from "@/views/pages/user-settings/ProfileImageSection";

export default {
  data () {
    return {
      username: 'Janaka Edirisinghe',
      name: this.$store.state.AppActiveUser.displayName,
      email: 'janaka@10qbit.com',
      company: '10Qbit Pvt Ltd',
      current_user: {},
      active2FADisabledPrompt: false,
      password: '',
      org: '',
    }
  },
  components: {
    TwoFAPopUp,
    ProfileImageSection,
  },
  mixins: [SuccessMessage, ErrorMessages],
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    themeMode: {
      get ()    { return this.$store.state.theme },
      set (val) { this.$store.dispatch('updateTheme', val) }
    },
  },
  watch: {
    'themeMode': {
      handler() {
        location.reload()

      },
      deep: true,
    }
  },
  async mounted() {
    await this.getCurrentUser()
  },
  methods: {
    async getCurrentUser() {
      this.$vs.loading()
      const {data} =  await profile.getCurrentUser()
      this.current_user = data.user.user
      this.org = data.user.tenant.domain
      this.$vs.loading.close()
    },
    async onChange2FA() {
      if(this.current_user.is_google_2fa_enable) {
        await this.$refs.twoFAPopUp.openPopup(this.current_user)
      } else {
        this.active2FADisabledPrompt = true
      }
    },
    async onClick2FADisable() {
      this.$vs.loading()
      try {
        await StaffRepository.disable2FA({ password: this.password })
        this.showSuccessMessage('2FA disabled successfully')
        await this.getCurrentUser()
      } catch (e) {
        await this.getCurrentUser()
        this.convertAndNotifyError(e)
      }
      this.password = ''
      this.$vs.loading.close()
    },
    onClick2FADisableCancel() {
      this.password = ''
      this.active2FADisabledPrompt = false
      this.current_user.is_google_2fa_enable = !this.current_user.is_google_2fa_enable
    },
  },
}
</script>
